import ToolTip from 'components/Tooltip';
import { Button } from 'primereact/button';
import { ChatbotContext } from 'providers/ChatbotProvider';
import { useContext } from 'react';

const BotTitle = ({ botDetails, onClickResetConversation }) => {
    const { addSessionLoading, botReplyLoading, expanded, setExpanded } = useContext(ChatbotContext);

    return (
        <div className="chatbot-header">
            <h1>logo</h1>
            <div className="chat-header-inner">
                <ToolTip side="top" content={'Reset Conversation'}>
                    <button
                        className='header-button'
                        disabled={botReplyLoading || addSessionLoading}
                        onClick={onClickResetConversation}
                        tabIndex={3}>
                        <img src={'https://storage.googleapis.com/seek-logos/ibexco-assests/refresh.svg'} alt="reset session" />
                    </button>
                </ToolTip>
                <div>
                    {!expanded && (
                        <ToolTip side="top" content={'Expand'}>
                            <button
                                className='header-button'
                                onClick={() => {
                                    setExpanded(true);
                                }}
                                tabIndex={4}>
                                <img
                                    src={'https://storage.googleapis.com/seek-logos/ibexco-assests/expand.svg'}
                                    alt="expand window"
                                />
                            </button>
                        </ToolTip>
                    )}

                    {expanded && (
                        <ToolTip side="top" content={'Collapse'}>
                            <button
                                className='header-button'
                                onClick={() => {
                                    setExpanded(false);
                                }}>
                                <img
                                    src={'https://storage.googleapis.com/seek-logos/ibexco-assests/collapse.svg'}
                                    alt="Collaspse"
                                />
                            </button>
                        </ToolTip>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BotTitle;
